<template>
    <div class="my-tcinfo">
        <van-nav-bar :title="title" left-span="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="dingbu">
            <van-tabs v-model="odType" @click="onClickTab">
                <van-tab title="日常消费" :name="1">
                </van-tab>
                <van-tab title="充值续卡" :name="2">
                </van-tab>
            </van-tabs>
        </div>
        <div style="margin-top: 90px">
            <div style="background-color: #EEEEEE;">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="xfLoad"
                >
                    <div class="items">
                        <div class="od-items" v-for="(item,index) in list" :key="index">
                            <div class="odbt">
                                <div>
                                    <span class="daodian">到店</span>
                                    <span class="odck">{{item.deptName}}</span>
                                </div>
                                <span class="odck1">订单号: {{item.orderNo}}</span>
                            </div>
                            <div class="od-item ">
                                <div class="odspan">{{item.createTime}}</div>
                                <div class="odspan">消费金额: ¥{{item.totalPrice}}</div>
                                <div class="odspan">结算方式: {{item.payName}}</div>
                                <div class="odspan1">内容详情</div>
                                <div class="odinfo" v-for="(it,i) in item.infos" :key="i">
                                    <div class="odi1">
                                        <span class="odi3">({{type[it.commodityType]}})</span>
                                        <span class="odi1">{{it.commodityName}}</span>
                                    </div>
                                    <span class="odi2">x1</span>
                                    <span class="odi2">¥{{it.price}}</span>
                                </div>
                            </div>
                            <div style="font-size: 12px;margin-top: 12px">获得红包 <span style="margin-left: 26px;">0</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>

        <!--        <van-popup v-model="show" position="right" style="width: 100%;height: 100%;background-color: #EEEEEE"-->
        <!--                   :overlay="true">-->
        <!--            <div class="popupcss">-->
        <!--                <div class="xq-tou">-->
        <!--                    <span>订单详情</span>-->
        <!--                    <span @click="fanhui">返回</span>-->
        <!--                </div>-->
        <!--                <div class="xq-items">-->
        <!--                    <div style="background-color: #ffffff;padding: 13px;padding-bottom: 50px;">-->
        <!--                        <div style="font-size: 13px;border-bottom: #EEEEEE solid 1px;padding-bottom: 5px">-->
        <!--                            <span class="daodian">到店</span><span>{{deptName}}</span>-->
        <!--                        </div>-->
        <!--                        <div class="tc-item">-->
        <!--                            <div class="tcinfo" style="padding-bottom: 8px">-->
        <!--                                <span class="tci1">名称</span>-->
        <!--                                <span class="tci2">属性</span>-->
        <!--                                <span class="tci2">类型</span>-->
        <!--                                <span class="tci2">价格</span>-->
        <!--                            </div>-->
        <!--                            <div class="tcinfo" style="margin-top: 8px;margin-bottom: 5px" v-for="item in orderInfos">-->
        <!--                                <span class="tci1">{{item.commodityName}}</span>-->
        <!--                                <div class="tci2">-->
        <!--                                    <span v-if="item.commodityType==0">-->
        <!--                                        <span v-if="item.commoditySign==0">项目</span>-->
        <!--                                        <span v-if="item.commoditySign!=0">套餐</span>-->
        <!--                                    </span>-->
        <!--                                    <span v-if="item.commodityType==1">卖品</span>-->
        <!--                                    <span v-if="item.commodityType==2">套餐</span>-->
        <!--                                    <span v-if="item.commodityType==3">开卡</span>-->
        <!--                                    <span v-if="item.commodityType==4">充值</span>-->
        <!--                                    <span v-if="item.commodityType==5">品项</span>-->
        <!--                                    <span v-if="item.commodityType==10">成品</span>-->
        <!--                                </div>-->
        <!--                                <div class="tci2">-->
        <!--                                    <span v-if="item.commodityType==0">-->
        <!--                                        <span v-if="item.commoditySign==0">消费</span>-->
        <!--                                        <span v-if="item.commoditySign!=0">消耗</span>-->
        <!--                                    </span>-->
        <!--                                    <span v-if="item.commodityType!=0">-->
        <!--                                        <span>消耗</span>-->
        <!--                                    </span>-->
        <!--                                </div>-->
        <!--                                <span class="tci2">{{item.price}}</span>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        <div style="margin-top: 30px">-->
        <!--                            <div style="font-size: 12px;margin-top: 18px">结算金额: {{order.totalPrice}}</div>-->
        <!--                            <div style="font-size: 12px;margin-top: 18px">消费时间: {{order.createTime}}</div>-->
        <!--                            <div style="font-size: 12px;margin-top: 18px">支付方式:-->
        <!--                                <span v-if="order.payType==0">会员卡<span style="margin-left: 3px"-->
        <!--                                                                       v-if="mcName">( {{mcName}} )</span></span>-->
        <!--                                <span v-if="order.payType==1">赠送金<span style="margin-left: 3px"-->
        <!--                                                                       v-if="mcName">( {{mcName}} )</span></span>-->
        <!--                                <span v-if="order.payType==2">现金</span>-->
        <!--                                <span v-if="order.payType==3">微信</span>-->
        <!--                                <span v-if="order.payType==4">支付宝</span>-->
        <!--                                <span v-if="order.payType==5">美团</span>-->
        <!--                                <span v-if="order.payType==6">抖音</span>-->
        <!--                                <span v-if="order.payType==7">混合支付</span>-->
        <!--                                <span v-if="order.payType==8">欠款</span>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </van-popup>-->
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '消费记录',
                odType: 1,
                deptId: '',
                token: '',

                type: {
                    0: "项目",
                    1: "卖品",
                    2: "套餐",
                    3: "开卡",
                    4: "充值",
                    5: "品项",
                    10: "成品",
                    11: "合作",
                },

                list: [],
                loading: false,
                finished: false,
                page: 1,


                czList: [],
                czLoading: false,
                czFinished: false,
                czPage: 1,

                show: false,
                order: {},
                orderInfos: [],
                deptName: '',
                mcName: '',
            };
        },
        async created() {
            document.title = "会员中心"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            onClickTab() {
                window.scrollTo({
                    top: 0,
                    // behavior: 'smooth' // 可选，让滚动有平滑效果
                });
                this.page = 1
                this.list = []
                this.finished = false
                this.loading = true
                this.xfLoad()
            },
            async xfLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    odType: this.odType,
                    currentPage
                }
                let res = await this.$get("/fw/getMdConsumptionPage", data)
                if (res.code == 200) {
                    const count = res.list.length
                    const newList = res.list
                    const list = this.list.concat(newList)
                    if (list.length < 30) {
                        this.list = this.quchong(list, "id")
                    } else {
                        this.list = list
                    }
                    this.page = this.page + 1
                    this.loading = false
                    if (count < 10 && count == 0) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            },

            async toDetails(orderId, deptName) {
                this.deptName = deptName
                this.show = true
                let data = {
                    orderId: orderId,
                }
                let res = await this.$get("/fw/getFwOrderDetails", data)
                this.order = res.order
                this.mcName = res.mcName
                this.orderInfos = res.orderInfos
            },

            fanhui() {
                this.show = false
            },

            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .my-tcinfo {
        height: 100vh;
    }

    .dingbu {
        position: fixed;
        width: 100%;
        top: 45px;
    }

    .items {
        display: flex;
        flex-direction: column;
    }

    .od-items {
        box-sizing: border-box;
        background-color: #ffffff;
        padding: 17px;
        margin: 11px 11px 0 11px;
    }

    .odbt {
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        padding-bottom: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .daodian {
        background-color: #174346;
        color: #fff;
        padding: 1px 6px;
        margin-right: 8px;
    }

    .odck {
        font-size: 12px;
    }

    .odck1 {
        font-size: 12px;
    }

    .od-item {
        margin-top: 9px;
        background-color: #F8F8F8;
        padding: 9px 12px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
    }

    .odspan {
        height: 24px;
        line-height: 24px;
    }

    .odspan1 {
        width: 100%;
        border-bottom: solid #e5e5e5 1px;
        height: 24px;
        line-height: 24px;
    }

    .odinfo {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 11px;
        margin-top: 10px;
    }

    .odi1 {
        width: 50%;
        height: 16px;
        line-height: 16px;
    }

    .odi2 {
        width: 20%;
        height: 16px;
        line-height: 16px;
        span-align: center;
    }

    .odi3 {
        width: 50%;
        height: 16px;
        line-height: 16px;
        color: #F09B69;
        margin-right: 6px;
    }

</style>
